import type { IconProps } from "./IconProps";

export const AngleSmallRightIcon = ({ height = 16, width = 16, color = "white" }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.98891 14L10.5916 9.05996C10.8531 8.77924 11 8.39855 11 8.0016C11 7.60466 10.8531 7.22396 10.5916 6.94324L5.98612 2L5 3.05836L9.60271 8.0016L5 12.9416L5.98891 14Z" fill={color} />
    </svg>
);
